import { render } from "./chart-of-account.vue?vue&type=template&id=e369a146&scoped=true"
import script from "./chart-of-account.vue?vue&type=script&lang=js"
export * from "./chart-of-account.vue?vue&type=script&lang=js"

import "./chart-of-account.vue?vue&type=style&index=0&id=e369a146&scoped=true&lang=css"

import exportComponent from "/home/runner/work/inventflux-frontend/inventflux-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e369a146"]])

export default __exports__